import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import BigHeader from "../../components/BigHeader";

function Outreach() {
    return (
        <div>

        <BigHeader headerText={'Outreach & Education'} backgroundImage={'https://static.igem.wiki/teams/4602/wiki/images/images/banner.png'}/>

        <Container>

          <Row>
            <Col>
              <p> Outreach and education is an essential part of iGEM. It enables for constructive conversations, both for lay audiences and for iGEM teams.Throughout the project, we engaged with our institutional home on a regular basis, the Learning Planet Community. This involved:</p>
              <ul>
                <li>Attending and presenting at institutional lab meetings.</li>
                <li>Presenting our work as part of the Institute's Discovery Days.</li>
              </ul>
              <p>Conversations at all these occurrences fed both our human practices & scientific development.</p>
            </Col>
          </Row>
          <Row>
            <Col>
              <Image style={{maxWidth: '500px'}} src="https://static.igem.wiki/teams/4602/wiki/images/outreach/ddays1.jpg" alt="Discovery Day on the 28th of September 2023. Discovery Days are semestrial opportunities for researchers to present their work, exchange ideas, and bounce back suggestions." />
              <p>Discovery Day on the 28th of September 2023. Discovery Days are semestrial opportunities for researchers to present their work, exchange ideas, and bounce back suggestions.</p>
            </Col>
            <Col>
              <Image style={{maxHeight: '375px'}} src="https://static.igem.wiki/teams/4602/wiki/images/outreach/57e76016-a3e5-4876-bea0-a29e650d225a.jpg" alt="Best way to get information you wouldn’t have thought about is from human interactions!" />
              <p>Best way to get information you wouldn’t have thought about is from human interactions!</p>
            </Col>
          </Row>

          <Row>
            <Col>
              <p>Throughout the project, we also actively engaged with the iGEM community, attending:</p>
              <ul>
                <li>Guidance events, such as “Documenting and communicating your project success”</li>
                <li>Scientific meet-ups, like the Toulouse meet-up in June</li>
              </ul>
              <Image style={{maxWidth: '500px'}} src="https://static.igem.wiki/teams/4602/wiki/images/outreach/toul.png" alt="Toulouse Meeting, June 2023" />
              <p>Toulouse Meeting, June 2023</p>
            </Col>
          </Row>
          <Row>
            <Col>
              <p>Importantly, we also <strong>reached out outside</strong> of institutional walls:</p>
              <ul>
                <li>By <strong>engaging with experts</strong>, as outlined by our integrated human practices</li>
                <li>By <strong>attending events</strong> around Paris, exhibitions & festivals included</li>
                <li>By <strong>reaching out to potential users</strong> by developing a <a href="https://docs.google.com/forms/d/e/1FAIpQLSfCJm6ZZHda9JNoOZeGHySlHX92ZZVLZtPwvZREe5MQOblYMA/viewform">Google form</a> to inform our product design, which we shared around, virtually and in person</li>
              </ul>
            </Col>
          </Row>
          <Row>
            <Col>
              <p>Finally, iGEM is also about <strong>bridging the gap between scientists and citizens</strong> on the topic of scientific biology. We organized two workshops with children aged 8+ on the topic of virology and infections. For details on the game we coordinated and organised on human biology & virology basics please get in touch with Laure. We devise 5 mini modulable games that explore: basics of human biology: from organ to cells, the body as city; difference between bacteria and virus; viral entry mechanisms: the cell as a kitchen; biological scales and mini-quizz. Whilst we developed a prototype version for our workshops, we are making a cleaner version of the games, which include tips, tricks and ice-breakers to get children talking about health and infection (e.g. have you ever been ill?).</p>
            </Col>
            <Col>
            <Image style={{maxWidth: '500px'}} src="https://static.igem.wiki/teams/4602/wiki/images/outreach/d3e7acfc-9fc0-4780-ad1e-da902b9ec1c8.jpg" alt="Toulouse Meeting, June 2023" />

            </Col>

          </Row>
        </Container>
        </div>

      );
    }
export default Outreach;
